import { Button, Divider, Modal, RangeSlider, Slider, Switch, Text } from "@mantine/core";
import React from "react";
import { useExplorerStorage } from "../ZustandState";
import { DatePickerInput } from "@mantine/dates";

interface Props {
    opened: boolean;
    close: () => void;
}

const ExplorerFiltersModal: React.FC<Props> = ({ opened, close }) => {
    const explorerStorage = useExplorerStorage((state) => state);

    return (
        <Modal
            opened={opened}
            onClose={close}
            title={
                <Text fz="h3" fw="bold">
                    Filters
                </Text>
            }
            centered
            padding={20}
            size="lg"
        >
            <Switch
                label="Include training mode games"
                checked={explorerStorage.includeTrainingModeGames}
                onChange={(e) => explorerStorage.setIncludeTrainingModeGames(e.currentTarget.checked)}
            />

            <Divider mt="lg" mb="lg" />

            <DatePickerInput
                mt="lg"
                label="From date"
                placeholder="Pick date"
                value={explorerStorage.fromDate || null}
                onChange={explorerStorage.setFromDate}
            />

            <DatePickerInput
                mt="md"
                label="To date"
                placeholder="Pick date"
                value={explorerStorage.toDate || null}
                onChange={explorerStorage.setToDate}
            />

            <Divider mt="lg" mb="lg" />

            <Text fz="sm">Rating</Text>
            <RangeSlider
                value={[explorerStorage.fromRating, explorerStorage.toRating]}
                onChange={([from, to]) => {
                    explorerStorage.setFromRating(from);
                    explorerStorage.setToRating(to);
                }}
                step={1}
                labelAlwaysOn
                max={3000}
                mt="xl"
                mb="xl"
            />

            <div className="flex justify-center items-center space-x-4">
                <Button
                    className="mt-6"
                    h="2.5rem"
                    variant="light"
                    color="gray"
                    onClick={() => {
                        close();
                    }}
                    fullWidth
                >
                    <span className="text-lg">Done</span>
                </Button>
            </div>
        </Modal>
    );
};

export default ExplorerFiltersModal;
